import './paedml-card.tag'
import './paedml-icon-modal.tag'
import './paedml-modal-delete.tag'
import './firewall/paedml-modal-createoredit-fwtemplate.tag'
import './firewall/paedml-modal-edit-accesslist.tag'

<paedml-card-fwtemplate>
  <paedml-card config={opts.config} perm={opts.perm} siblings={opts.siblings} ref='card'>

    <virtual if={canCreate()}>
      <paedml-icon-modal icon="anlegen" target="#{prefix}-create-modal" title="Whitelist-Vorlage anlegen" />
      <paedml-modal-createoredit-fwtemplate prefix="{prefix}-create" usersuffix="{prefix}"
        heading="{config.contentTitle}: Whitelist-Vorlage anlegen" opname="Whitelist-Vorlage anlegen" api={restApi} />
    </virtual>

    <!--  <virtual if="{selectedExactlyOne() && isPermitted('editMy')}">
     <paedml-icon-modal icon="bearbeiten" target="#{prefix}-edit-modal" title="Whitelist-Vorlage bearbeiten" />
      <paedml-modal-createoredit-fwtemplate prefix="{prefix}-edit" edit={true} selectedrowsfunc={getSelectedRows}
        heading="{config.contentTitle}: Whitelist-Vorlage bearbeiten" opname="Änderung speichern" api={restApi} />
    </virtual>  -->

    <virtual if="{canEdit()}">
      <paedml-icon-modal icon="bearbeiten" target="#{prefix}-edit-modal" title="Whitelist-Vorlage bearbeiten" />
      <paedml-modal-createoredit-fwtemplate prefix="{prefix}-edit" edit={true} selectedrowsfunc={getSelectedRows}
        heading="{config.contentTitle}: Whitelist-Vorlage bearbeiten" opname="Änderung speichern" api={restApi} />
    </virtual>

    <virtual if="{selectedExactlyOne() && isPermitted('fwaccess') && parent.canEditWhitelist(this)}">
      <paedml-icon-modal icon="fas-list" target="#{prefix}-edit-fw-modal" title="Whitelist zuweisen" />
      <paedml-modal-edit-accesslist prefix="{prefix}-edit-fw" variant="template" selectedrowsfunc={getSelectedRows}
        heading="{config.contentTitle}: Whitelist zuweisen" opname="Änderung speichern" api={restApi} edit={true} />
    </virtual>

    <virtual if="{canDelete()}">
      <paedml-icon-modal icon="loeschen" target="#{prefix}-delete-modal" title="Whitelist-Vorlage löschen" />
      <paedml-modal-delete idtextcol="1" patient="{{singular: 'Whitelist-Vorlage', plural: 'Whitelist-Vorlagen', as: 'die'}}" heading="{config.contentTitle}: Whitelist-Vorlage(n) löschen"
        prefix="{prefix}-delete" selectedrowsfunc={getSelectedRows}
        api={restApi} />
    </virtual>

  </paedml-card>

  <script>
    import Session from '../store/session'

    this.prefix = opts.prefix

    this.isAdmin = () => Session.user.roleAbbrev === 'FADM ' || Session.user.roleAbbrev === 'SYSA' || Session.user.roleAbbrev === 'SADM' || Session.user.roleAbbrev === 'RADM'

    this.canEditWhitelist = (ctx) => this.isAdmin() || ctx.isSchoolSettingMatchingValue('teacherWhitelistAccessEnabled', 'true')
  </script>
</paedml-card-fwtemplate>
